import { render, staticRenderFns } from "./EditarPerfilUsuario.vue?vue&type=template&id=880fbe7e&"
import script from "./EditarPerfilUsuario.vue?vue&type=script&lang=js&"
export * from "./EditarPerfilUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports